import { render } from "./course-cascader.vue?vue&type=template&id=55856751&scoped=true"
import script from "./course-cascader.vue?vue&type=script&lang=js"
export * from "./course-cascader.vue?vue&type=script&lang=js"

import "./course-cascader.vue?vue&type=style&index=0&id=55856751&lang=scss"
import "./course-cascader.vue?vue&type=style&index=1&id=55856751&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55856751"]])

export default __exports__